import cn from 'classnames';
import * as React from 'react';

import { ValueProp } from '../../BaseClickable';
import BaseButton, { BaseButtonProps } from '../BaseButton';

import s from './ButtonText.module.scss';

const ButtonText = <V extends ValueProp>(
  { className, disabled, ...props }: BaseButtonProps<V>,
  ref: React.ForwardedRef<any>
) => {
  return (
    <BaseButton
      {...props}
      className={cn(className, s['button-text'], disabled && s['button-text_disabled'])}
      disabled={disabled}
      // @ts-ignore
      ref={ref}
    />
  );
};

export default React.forwardRef(ButtonText) as typeof ButtonText;
